import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Controller, useForm } from 'react-hook-form';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';
import { useEffect, useState } from 'react';
import VnButton from '@ui/components/VnButton';
import { selectStyles } from '@ui/styles/select-style';
import VnSelectText from '@ui/components/VnSelectText';
import { Link, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { getAllBrandsAsync } from '@application/features/brands/BrandThunk';
import AsyncSelect from 'react-select/async';
import { getWorkOrdersListWithClientAsync } from '@application/features/purchaseInvoiceLines/purchaseInvoiceLineThunk';
import VnValidation from '@ui/components/VnValidation';
import { getAllWorkOrdersByIdAsync } from '@application/features/workorders/workorderThunk';
import { NumericFormat } from 'react-number-format';
import { createPurchaseInvoiceLineAsync, deletePurchaseInvoiceLineAsync, getAllArticalsAsync, getArticalByIdAsync, getPurchaseInvoiceLineByIdAsync, updatePurchaseInvoiceLineAsync } from '@application/features/purchaseInvoiceLines/purchaseInvoiceLineThunk';
import VnConfirmationModel from '@ui/components/VnConfirmationModel';
const AddPurchaseInvoiceLineForm = ({ onClose, purchaseInvoiceLineId, onPurchaseInvoiceLineGridUpdate, isPurchaseInvoiceDisable }) => {
    const { setValue, handleSubmit, register, watch, control, clearErrors, formState: { errors } } = useForm({
        defaultValues: {
            netPrice: 0
        }
    });
    const dispatch = useAppDispatch();
    const { ArticlesDropDown, Articles } = useAppSelector((state) => state.orderLine);
    const { articles } = useAppSelector((state) => state.artical);
    const { brandsBrandLableDropdown, brandsUnitDropdown } = useAppSelector((state) => state.brands);
    const [articleNumber, setArticleNumber] = useState('');
    const [selectedArticalId, setSelectedArticalId] = useState('');
    const [brand, setBrand] = useState('');
    const [isPurchaseInvoiceLineDeletePopup, setIsPurchaseInvoiceLineDeletePopup] = useState(false);
    const [selectedWorkOrderValue, setSelectedWorkOrderValue] = useState();
    const quantity = watch('quantity');
    const netPrice = watch('netPrice');
    const [isArticleTableOpen, setIsArticleTableOpen] = useState(false);
    const [showArticleGridHeader] = useState(true);
    const { WorkOrderListWithClientOptions } = useAppSelector((state) => state.purchaseinvoiceline);
    const { id } = useParams();
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [isRecievedToggleValue, setIsReceivedToggleValue] = useState(false);
    const [isToogled, setIsToggled] = useState(false);
    const defaultSortingCriteria = {
        sortColumnKey: 'articleNumber',
        sortDirection: 'desc'
    };
    useEffect(() => {
        if (quantity && netPrice) {
            const total = quantity * netPrice;
            setValue('totaaldebrag', total);
        }
        else {
            setValue('totaaldebrag', 0);
        }
    }, [quantity, netPrice]);
    const unitPrice = watch('grossPrice');
    const discount = watch('discount');
    const workOrderId = watch('workOrderId');
    useEffect(() => {
        if (id) {
            dispatch(getAllArticalsAsync());
            dispatch(getAllBrandsAsync());
        }
    }, [dispatch, id]);
    useEffect(() => {
        if (purchaseInvoiceLineId > 0) {
            setArticleNumber('');
            setValue('name', '');
            setValue('type', '');
            setBrand('');
            setValue('data', '');
            setValue('supplierArticleNumber', '');
            setValue('unit', '');
            setValue('grossPrice', 0);
            setValue('discount', 0);
            setValue('netPrice', 0);
            setValue('quantity', 0);
            setValue('workOrderId', 0);
            dispatch(getPurchaseInvoiceLineByIdAsync(purchaseInvoiceLineId))
                .unwrap()
                .then((res) => {
                const articalName = Articles?.find((x) => x.articleNumber === res.articleNumber)?.name;
                if (res.articleNumber && res.articleNumber.trim() !== '' && articalName && articalName.trim() !== '') {
                    setArticleNumber(res.articleNumber + ' - ' + articalName ?? '');
                }
                else {
                    setArticleNumber(res.articleNumber ?? '');
                }
                setIsToggled(res.received);
                setIsReceivedToggleValue(res.received);
                setSelectedArticalId(res.articleId?.toString() ?? '');
                setValue('name', res.name);
                setValue('type', res.type);
                setBrand(res.brand ?? '');
                setValue('data', res.data);
                setValue('supplierArticleNumber', res.supplierArticleNumber);
                setValue('quantity', res.quantity);
                setValue('unit', res.unit);
                setValue('grossPrice', res.grossPrice);
                setValue('discount', res.discount);
                setValue('netPrice', res.netPrice);
                setValue('workOrderId', res.workOrderId);
                setValue('received', res.received);
                setSelectedWorkOrderValue(res.workOrderId);
                if (res.workOrderId)
                    dispatch(getAllWorkOrdersByIdAsync(res.workOrderId))
                        .unwrap()
                        .then((res) => {
                        workOrderAsyncList(res.workOrderNumber);
                    })
                        .catch((error) => {
                        console.error('Bad request.');
                    });
            });
        }
    }, [dispatch, purchaseInvoiceLineId]);
    function onArticalNumberChange(selectedValue, selectedLable) {
        setArticleNumber(selectedLable);
        setSelectedArticalId(selectedValue);
        if (selectedValue && selectedValue !== '') {
            setValue('name', '');
            setValue('type', '');
            setBrand('');
            setValue('data', '');
            setValue('supplierArticleNumber', '');
            setValue('unit', '');
            setValue('grossPrice', 0);
            setValue('discount', 0);
            setValue('netPrice', 0);
            setValue('quantity', 0);
            dispatch(getArticalByIdAsync(parseInt(selectedValue)))
                .unwrap()
                .then((res) => {
                setValue('name', res.name);
                setValue('type', res.type);
                setBrand(res.brand ?? '');
                setValue('brand', res.brand ?? '');
                setValue('supplierArticleNumber', res.supplierArticleNumber);
                setValue('unit', res.unit);
                setValue('grossPrice', res.grossPrice);
                setValue('discount', res.discount);
                setValue('netPrice', res.netPrice);
            });
            clearErrors('name');
        }
    }
    const onSubmit = (data) => {
        if (id && purchaseInvoiceLineId === 0 && !isPurchaseInvoiceDisable) {
            data.purchaseInvoiceId = parseInt(id);
            if (selectedArticalId && selectedArticalId.trim() !== '') {
                data.articleId = parseInt(selectedArticalId);
                data.articleNumber = Articles?.find((x) => x.id === parseInt(selectedArticalId))?.articleNumber;
            }
            else {
                data.articleNumber = articleNumber;
            }
            data.brand = brand;
            dispatch(createPurchaseInvoiceLineAsync(data))
                .unwrap()
                .then((res) => {
                onClose();
                onPurchaseInvoiceLineGridUpdate();
            })
                .catch((error) => {
                console.error('Bad request.');
            });
        }
        else if (id && purchaseInvoiceLineId > 0 && !isPurchaseInvoiceDisable) {
            data.id = purchaseInvoiceLineId;
            data.purchaseInvoiceId = parseInt(id);
            if (selectedArticalId && selectedArticalId.trim() !== '') {
                data.articleId = parseInt(selectedArticalId);
                data.articleNumber = Articles?.find((x) => x.id === parseInt(selectedArticalId))?.articleNumber;
            }
            else {
                data.articleNumber = articleNumber;
            }
            data.brand = brand;
            dispatch(updatePurchaseInvoiceLineAsync(data))
                .unwrap()
                .then((res) => {
                onClose();
                onPurchaseInvoiceLineGridUpdate();
            })
                .catch((error) => {
                console.error('Bad request.');
            });
        }
    };
    function onBrandChange(selectedValue, selectedLable) {
        setBrand(selectedLable);
        setValue('brand', selectedLable);
    }
    function workOrderAsyncList(inputValue) {
        if (inputValue.length > 2) {
            return dispatch(getWorkOrdersListWithClientAsync(inputValue))
                .unwrap()
                .then((res) => {
                const options = res.map((workOrder) => ({
                    label: workOrder.workOrderNumber,
                    value: workOrder.id
                }));
                return options;
            });
        }
        return Promise.resolve([]);
    }
    const deletePurchaseInvoiceLine = () => {
        setIsPurchaseInvoiceLineDeletePopup(true);
    };
    const onCancelDeleteClicked = () => {
        setIsPurchaseInvoiceLineDeletePopup(false);
    };
    const onDeleteClicked = () => {
        dispatch(deletePurchaseInvoiceLineAsync(purchaseInvoiceLineId))
            .unwrap()
            .then(() => {
            onClose();
            setIsPurchaseInvoiceLineDeletePopup(false);
            onPurchaseInvoiceLineGridUpdate();
        })
            .catch((error) => {
            console.error('Bad request.');
        });
    };
    //---------------Handling bruto,korting,neto and vekop price logic-----------------------
    const triggerUpdatedPricesLogic = () => {
        if (isInitialLoad) {
            setIsInitialLoad(false);
        }
    };
    useEffect(() => {
        if (!isInitialLoad) {
            if (unitPrice && discount) {
                // Case 2: When both gross price and discount change, calculate net price and set selling price
                const calculatedNetPrice = unitPrice - (unitPrice * discount) / 100;
                setValue('netPrice', calculatedNetPrice);
                setValue('sellingPrice', unitPrice);
            }
            if (unitPrice && !discount) {
                //case 1 When gross price changes, set selling price and clear net price
                setValue('sellingPrice', unitPrice);
                setValue('netPrice', unitPrice);
            }
        }
    }, [unitPrice, discount, isInitialLoad]);
    useEffect(() => {
        if (!isInitialLoad) {
            if (!unitPrice && !discount && netPrice) {
                // Case 3: When only net price changes, calculate selling price as net price + 30%
                const calculatedSellingPrice = netPrice * 1.3;
                setValue('sellingPrice', calculatedSellingPrice);
            }
        }
    }, [netPrice, isInitialLoad]);
    function handleReceivedToggle(checked) {
        if (!isRecievedToggleValue) {
            setIsToggled(checked);
            setValue('received', checked);
        }
    }
    //---------------End of region handling bruto,korting,neto and vekop price logic-----------------------
    return (_jsxs(_Fragment, { children: [_jsxs("form", { onSubmit: handleSubmit(onSubmit), className: 'Vn-form-FormMain', noValidate: true, children: [_jsx("div", { className: 'row', children: _jsx("div", { className: 'col-md-6', children: _jsxs("span", { className: 'Vn-form-SpeedSpan', children: [_jsxs("label", { className: 'Vn-toggle-button-switch', children: [_jsx("input", { type: 'checkbox', checked: isToogled, onChange: (e) => handleReceivedToggle(e.target.checked) }), _jsx("span", { className: 'Vn-toggle-button-slider Vn-toggle-button-round' })] }), _jsx("span", { className: 'Vn-form-text ml-2', children: "Ontvangen" })] }) }) }), _jsxs("div", { className: 'row mt-4', children: [_jsxs("div", { className: 'form-group col-md-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Artikelnummer" }), _jsx(VnSelectText, { valueOptions: ArticlesDropDown, value: articleNumber, onOptionChange: onArticalNumberChange, listtype: 'articleNumber', placeHolder: 'Selecteer artikelnummer' })] }), _jsxs("div", { className: 'form-group col-md-6', children: [_jsxs("label", { className: 'form-label vn-text-label', children: ["Naam", _jsx("span", { className: 'vn-AsterikMark', children: "*" })] }), _jsx("input", { id: 'name', type: 'text', placeholder: 'Voer naam in', className: 'form-control vn-Input', ...register('name', {
                                            required: 'Dit veld is verplicht'
                                        }) }), _jsx(VnValidation, { fieldError: errors.name })] })] }), _jsxs("div", { className: 'row mt-4', children: [_jsxs("div", { className: 'form-group col-md-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Merk" }), _jsx(VnSelectText, { lableOptions: brandsBrandLableDropdown, value: brand, onOptionChange: onBrandChange, listtype: 'brand', placeHolder: 'Selecteer merk' })] }), _jsxs("div", { className: 'form-group col-md-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Type" }), _jsx("input", { id: 'type', type: 'text', placeholder: 'Voer type in', className: 'form-control vn-Input', ...register('type') })] })] }), _jsx("div", { className: 'row mt-4', children: _jsxs("div", { className: 'form-group col-md-12', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Gegevens" }), _jsx("textarea", { className: 'vn-Input', ...register('data'), style: { height: 150, width: '100%', borderRadius: '3px' } })] }) }), _jsxs("div", { className: 'row mt-4', children: [_jsxs("div", { className: 'form-group col-md-6', children: [workOrderId ? _jsx(Link, { className: 'vn-anchor-style', target: '_blank', to: `/admin/WorkordersTabs/${workOrderId}`, children: "Werkorder" })
                                        :
                                            _jsx(Link, { className: 'vn-anchor-style', to: '', children: "Werkorder" }), _jsx("div", { className: 'mt-8', children: _jsx(AsyncSelect, { name: 'workOrderId', styles: selectStyles, value: WorkOrderListWithClientOptions?.find((c) => c.value == selectedWorkOrderValue), onChange: (selectedOption) => {
                                                setValue('workOrderId', selectedOption.value);
                                                setSelectedWorkOrderValue(selectedOption?.value ? selectedOption?.value.toString() : '');
                                            }, loadOptions: workOrderAsyncList, placeholder: 'Selecteer...' }) })] }), _jsx("div", { className: 'form-group col-md-6' })] }), _jsxs("div", { className: 'row mt-4', children: [_jsxs("div", { className: 'form-group col-md-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Aantal" }), _jsx(Controller, { name: 'quantity', control: control, render: ({ field: { onChange, value } }) => (_jsx(NumericFormat, { className: 'form-control vn-Input', placeholder: 'Voer aantal in', value: value || '', onValueChange: ({ value }) => {
                                                const inputValue = value;
                                                if (inputValue === '') {
                                                    onChange(null);
                                                }
                                                else {
                                                    onChange(inputValue);
                                                }
                                            }, thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, allowNegative: false, isAllowed: ({ floatValue }) => floatValue === undefined || (floatValue >= 0 && floatValue <= 999999.99) })) })] }), _jsxs("div", { className: 'form-group col-md-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Eenheid" }), _jsx(Controller, { name: 'unit', control: control, render: ({ field: { onChange, value } }) => (_jsx(Select, { placeholder: 'Eenheid', isSearchable: true, styles: selectStyles, value: brandsUnitDropdown?.find((c) => c.label === value), options: brandsUnitDropdown && brandsUnitDropdown, onChange: (val) => onChange(val?.label) })) })] })] }), _jsxs("div", { className: 'row mt-4', children: [_jsxs("div", { className: 'form-group col-md-3', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Bruto Prijs" }), _jsx(Controller, { name: 'grossPrice', control: control, render: ({ field: { onChange, value } }) => (_jsx(NumericFormat, { placeholder: 'Voer bruto prijs in', className: 'form-control vn-Input', value: value || '', onValueChange: ({ value }) => {
                                                if (value != unitPrice?.toString()) {
                                                    triggerUpdatedPricesLogic();
                                                }
                                                const inputValue = value;
                                                if (inputValue === '') {
                                                    onChange(null);
                                                    setValue('sellingPrice', 0);
                                                    setValue('netPrice', 0);
                                                }
                                                else {
                                                    onChange(inputValue);
                                                }
                                            }, thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, allowNegative: false, isAllowed: ({ floatValue }) => floatValue === undefined || (floatValue >= 0 && floatValue <= 999999.99) })) })] }), _jsxs("div", { className: 'form-group col-md-3', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Korting" }), _jsx(Controller, { name: 'discount', control: control, render: ({ field: { onChange, value } }) => (_jsx(NumericFormat, { className: 'form-control vn-Input', placeholder: 'Voer korting in', value: value || '', onValueChange: ({ value }) => {
                                                if (value != discount?.toString()) {
                                                    triggerUpdatedPricesLogic();
                                                }
                                                const inputValue = value;
                                                if (inputValue === '') {
                                                    onChange(null);
                                                }
                                                else {
                                                    onChange(inputValue);
                                                }
                                            }, thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, allowNegative: false, isAllowed: ({ floatValue }) => floatValue === undefined || (floatValue >= 0 && floatValue <= 100) })) })] }), _jsxs("div", { className: 'form-group col-md-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Netto Prijs" }), _jsx(Controller, { name: 'netPrice', control: control, render: ({ field: { onChange, value } }) => (_jsx(NumericFormat, { disabled: !unitPrice && !discount ? false : true, className: 'form-control vn-Input', placeholder: '', value: value?.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), onValueChange: ({ value }) => {
                                                if (value != unitPrice?.toString()) {
                                                    triggerUpdatedPricesLogic();
                                                }
                                                const inputValue = value;
                                                if (inputValue === '') {
                                                    onChange(null);
                                                }
                                                else {
                                                    onChange(inputValue);
                                                }
                                            }, thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, allowNegative: false, isAllowed: ({ floatValue }) => floatValue === undefined || (floatValue >= 0 && floatValue <= 999999.99) })) })] })] }), _jsxs("div", { className: 'row mt-4', children: [_jsx("div", { className: 'form-group col-md-6' }), _jsxs("div", { className: 'form-group col-md-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Totaal Bedrag" }), _jsx(Controller, { name: 'totaaldebrag', control: control, render: ({ field: { onChange, value } }) => (_jsx(NumericFormat, { disabled: true, className: 'form-control vn-Input', placeholder: '', value: value?.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), onValueChange: ({ value }) => {
                                                const inputValue = value;
                                                if (inputValue === '') {
                                                    onChange(null);
                                                }
                                                else {
                                                    onChange(inputValue);
                                                }
                                            }, thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, allowNegative: false })) })] })] }), _jsx("div", { className: 'vn-Form_Footer mt-4', children: _jsxs("div", { style: { display: 'flex', marginLeft: 'auto' }, children: [_jsx(VnButton, { customClassName: 'Vn-cancel-button', mode: 'secondary', onClick: onClose, type: 'button', isDisabled: isPurchaseInvoiceDisable, children: "Annuleren" }), purchaseInvoiceLineId > 0 ? (_jsxs(_Fragment, { children: [_jsx(VnButton, { style: { marginLeft: '8px' }, customClassName: 'vn-popup-delete-button', mode: 'danger', type: 'button', onClick: () => deletePurchaseInvoiceLine(), isDisabled: isPurchaseInvoiceDisable || isRecievedToggleValue, children: "Verwijderen" }), _jsx(VnButton, { customClassName: 'Vn-save-button vn-popup-save-button', mode: 'primary', type: 'submit', isDisabled: isPurchaseInvoiceDisable, children: "Opslaan" })] })) : (_jsx(VnButton, { customClassName: 'Vn-save-button vn-popup-save-button', mode: 'primary', type: 'submit', isDisabled: isPurchaseInvoiceDisable, children: "Opslaan" }))] }) })] }), _jsx(VnConfirmationModel, { title: 'Wilt u dit record verwijderen?', onCancel: () => onCancelDeleteClicked(), onConfirm: () => onDeleteClicked(), onOpen: isPurchaseInvoiceLineDeletePopup })] }));
};
export default AddPurchaseInvoiceLineForm;
